<template>
  <div class="p-4 sm:p-6 max-w-[1920px] mx-auto">
    <VuepalLink
      :to="to"
      class="teaser group sm:mb-12 border-0 shadow-none flex flex-col overflow-hidden rounded-[8px]"
    >
      <div class="sm:relative">
        <div
          class="relative w-full aspect-[1872/850] overflow-hidden rounded-t-[8px]"
        >
          <MediaImage
            v-if="media"
            v-bind="media"
            :image-style="imageStyle"
            hide-caption
            class="size-full object-cover"
          />
          <div
            v-else
            class="rounded-[4px] flex items-center justify-center w-full h-auto object-cover shrink-0 bg-lightGreenBg aspect-[412/309]"
          />
          <div
            v-if="tag"
            class="absolute left-8 top-6 bg-lightGreenBg text-darkGreen rounded-full h-14 px-7 mr-2 flex items-center justify-center transition-all duration-300 shadow-lg border-none cursor-pointer"
          >
            {{ tag }}
          </div>
        </div>
        <div
          :class="[
            'w-full flex flex-col justify-center bg-lightGreen transition-colors duration-300',
            'sm:absolute sm:right-6 rounded-b-[4px] md:rounded-t-[4px] sm:max-w-[426px] sm:z-10',
            infoBoxPosition === 'top' ? 'sm:top-6' : 'sm:bottom-6',
            'p-6 sm:p-9',
            infoBoxPosition !== 'small' ? 'group-hover:bg-yellow' : '',
          ]"
        >
          <div class="flex justify-between items-center">
            <h3
              class="text-xl md:text-3xl font-bold text-darkGreen leading-none"
            >
              {{ title }}
            </h3>
            <div
              class="bg-darkGreen rounded-full size-[60px] flex items-center justify-center shadow-lg cursor-pointer shrink-0"
            >
              <SpriteSymbol
                name="icon-arrow-right"
                class="size-10 text-white"
              />
            </div>
          </div>
          <div
            v-if="text"
            class="text-md md:text-xl text-darkGreen mt-5"
            v-html="text"
          />
        </div>
      </div>
    </VuepalLink>
  </div>
</template>

<script lang="ts" setup>
import type { MediaImageFragment } from '#graphql-operations'

defineProps<{
  title: string
  text?: string
  to: string
  media?: MediaImageFragment
  tag?: string
  hasParent?: boolean
  infoBoxPosition?: string
}>()

const imageStyle = defineImageStyle({
  type: 'sizes',
  aspectRatio: 1872 / 850,
  sizes: {
    xs: 768,
    sm: 1024,
    md: 1280,
    lg: 1380,
    xl: 2561,
  },
})
</script>
